import React from 'react'
import { Link } from 'react-router-dom'
import '../styles/TermsOfService.css'

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="legal-doc">
        <header className="legal-doc-header">
          <Link to="/" className="legal-back">
            ← Back to Home
          </Link>
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <div className="legal-doc-body">
          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using our website and services, you accept and agree to be bound by the terms and
              provisions of this agreement. If you do not agree to abide by the above, please do not use this
              service.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Service</h2>
            <p>We provide software development and digital services including:</p>
            <ul>
              <li>Custom website development</li>
              <li>Mobile application development</li>
              <li>Custom software solutions</li>
              <li>QR-code menu systems</li>
              <li>Reservation systems</li>
              <li>Single page portfolios</li>
              <li>Consultation and support services</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. User Responsibilities</h2>
            <p>As a user of our services, you agree to:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account information</li>
              <li>Use our services only for lawful purposes</li>
              <li>Not interfere with or disrupt our services</li>
              <li>Respect intellectual property rights</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Payment Terms</h2>
            <p>Payment terms for our services include:</p>
            <ul>
              <li>All prices are quoted in Euros (€)</li>
              <li>Payment is required before project commencement</li>
              <li>Additional revisions may incur additional charges</li>
              <li>Refunds are handled on a case-by-case basis</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Project Terms</h2>
            <p>For all development projects:</p>
            <ul>
              <li>Project timelines will be agreed upon before commencement</li>
              <li>Client feedback and approval is required at key milestones</li>
              <li>Final deliverables will be provided upon full payment</li>
              <li>Post-launch support terms will be specified in project agreements</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Intellectual Property</h2>
            <p>Intellectual property rights are as follows:</p>
            <ul>
              <li>We retain rights to our proprietary code and frameworks</li>
              <li>Clients own the rights to their custom content and branding</li>
              <li>Third-party assets remain under their respective licenses</li>
              <li>Portfolio rights allow us to showcase completed work</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              We provide our services &quot;as is&quot; and make no warranties about the reliability, accuracy, or
              completeness of our services. We shall not be liable for any indirect, incidental, or consequential
              damages.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Termination</h2>
            <p>Either party may terminate services with written notice. Upon termination:</p>
            <ul>
              <li>All outstanding payments become due immediately</li>
              <li>Access to services may be suspended</li>
              <li>Data will be handled according to our privacy policy</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with applicable law, without regard to
              conflict of law provisions.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon
              posting. Your continued use of our services constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Contact Information</h2>
            <p>For questions about these Terms of Service, please contact us at:</p>
            <div className="contact-info">
              <p>Email: thedeverseagency@gmail.com</p>
              <p>We will respond to your inquiry within 24 hours.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default TermsOfService
